
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Tooltip from '@/components/Tooltip.vue'
import FinalPriceLabel from '@/components/FinalPriceLabel.vue'
import { countRemainingTimeForShipping } from '@/utils/common'

export default Vue.extend({
  components: {
    Tooltip,
    FinalPriceLabel
  },
  props: {
    gifteeProduct: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    calcTimeInterval: number | null,
    bodyTheme: string,
    timeLeft: string
  } {
    return {
      calcTimeInterval: null,
       bodyTheme: 'sw-Tooltip_Light',
      timeLeft: ''
    }
  },
  computed: {
    ...mapGetters([
      'estimate'
    ])
  },
  created() {
    this.calcTimeInterval = window.setInterval(() => {
      this.timeLeft = countRemainingTimeForShipping()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.calcTimeInterval!)
  }
})
